import React, { FC, useCallback, useState } from "react";
import MessageForm, { MessageFormData } from "../MessageForm/MessageForm";

export interface PrechatFormProps {
    onSubmit(data: MessageFormData): void;
}

const PrechatForm: FC<PrechatFormProps> = props => {
    const [sent, setSent] = useState<boolean>(false);

    const { onSubmit } = props;

    const handleSubmit = useCallback((msg: MessageFormData) => {
        onSubmit(msg);
        setSent(true);
    }, [onSubmit]);

    return (
        <>
            {!sent && <MessageForm
                title="Introduce yourself!"
                onSubmit={handleSubmit}
            />}
        </>
    );
}


export default PrechatForm;
